'use client';
import { DropdownIcon } from '@/components/icons/svg-icons';
import { OddsButton } from '@/components/widgets/odds-button';
import { useAccountInfo } from '@/hooks/query/account';
import { getTeamName } from '@/utils/odds-utils';
import { OutrightMarket, SportMatchModel } from '@nf/types/odds'
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { MatchOddsLoadingWrapper } from '../../match-odds-loading-wrapper';

interface CardOutrightMatchProps {
	match: SportMatchModel;
	markets: OutrightMarket[];
	teamNameMap?: Map<number, string>;
	isLoading: boolean;
}
export const CardOutrightMatch = ({
	match,
	markets,
	teamNameMap,
	isLoading
}: CardOutrightMatchProps) => {
	const { user } = useAccountInfo();
	const t = useTranslations('General');
	const [isShowMore, setIsShowMore] = useState<boolean>(false);
	const onShowMoreButtonClick = () => {
		setIsShowMore(!isShowMore);
	}

	return (
		<div
			className="match"
			data-open={isShowMore}
		>
			<MatchOddsLoadingWrapper isLoading={isLoading}>
				{
					markets.sort((a, b) => {
						// sort by odds & team name (不可使用 localeCompare, 因中英文混雜排序會不如預期)
						let compare = a.Price - b.Price;
						if (compare === 0) {
							const teamNameA = getTeamName(a.TeamId, teamNameMap);
							const teamNameB = getTeamName(b.TeamId, teamNameMap);
							if (teamNameA > teamNameB) {
								compare = 1;
							} else if (teamNameA < teamNameB) {
								compare = -1;
							}
						}
						return compare;
					}).map(market => {
						return (
							<OddsButton
								key={market.MarketId}
								match={match}
								market={market}
								homeTeamName={''}
								awayTeamName={''}
								betTeam={''}
								originalPrice={market.Price}
								goal={getTeamName(market.TeamId, teamNameMap)}
								type="OT"
								sport={999}
								oddsType={user?.OType}
								accountStatus={user?.ActStatus ?? 0}
							/>
						)
					})
				}
				{
					markets.length > 6 && (
						<div
							className="btn-show-more"
							data-open={isShowMore}
							onClick={onShowMoreButtonClick}
						>
							<span>{isShowMore ? t('lbl_GalaxyShowless') : t('lbl_GalaxyShowmore')}</span>
							<DropdownIcon />
						</div>
					)
				}
			</MatchOddsLoadingWrapper>
		</div>
	)
}